var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFlagColored = function SvgIcFlagColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    transform: "translate(3 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5D71",
    d: "M1.5 9.5v-9l10 4.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    x: 0.5,
    y: 0.5,
    fill: "#F3D9DA",
    rx: 1
  }))));
};
export default SvgIcFlagColored;